export let AUTONOMOUS_COMPONENT_NAMES = /*#__PURE__*/function (AUTONOMOUS_COMPONENT_NAMES) {
  AUTONOMOUS_COMPONENT_NAMES["ALWAYS_INCLUDED_FEATURES"] = "AlwaysIncludedFeatures";
  AUTONOMOUS_COMPONENT_NAMES["FAQ"] = "Faq";
  AUTONOMOUS_COMPONENT_NAMES["MARKETING_CARDS"] = "MarketingCards";
  AUTONOMOUS_COMPONENT_NAMES["PRODUCTS_GRID"] = "ProductsGrid";
  AUTONOMOUS_COMPONENT_NAMES["SALE_BANNER"] = "SaleBanner";
  AUTONOMOUS_COMPONENT_NAMES["SALE_DISCLAIMER"] = "SaleDisclaimer";
  AUTONOMOUS_COMPONENT_NAMES["TITLE"] = "Title";
  AUTONOMOUS_COMPONENT_NAMES["ACCEPTED_PAYMENT_METHODS"] = "AcceptedPaymentMethods";
  AUTONOMOUS_COMPONENT_NAMES["MONEY_BACK_GUARANTEE"] = "MoneyBackGuarantee";
  AUTONOMOUS_COMPONENT_NAMES["HEADER_STRIP"] = "HeaderStrip";
  AUTONOMOUS_COMPONENT_NAMES["PRICE"] = "Price";
  return AUTONOMOUS_COMPONENT_NAMES;
}({});

/** TYPE UTILS */

// Converts a union of two types into an intersection
// i.e. A | B -> A & B

// Flattens two union types into a single type with optional values
// i.e. FlattenUnion<{ a: number, c: number } | { b: string, c: number }> = { a?: number, b?: string, c: number }

/**
 * Transforms a type by renaming keys ending with "Data" to keys ending with "Query"
 * and removes keys ending with "Data" from the resulting type.
 * @typeparam T - The input type to transform
 * @example
 * // Example usage:
 * type InputType = {
 *   userData: string;
 *   productData: number;
 *   orderDetails: boolean;
 * };
 *
 * type TransformedType = DataToQuery<InputType>;
 * // TransformedType is { userQuery: QueryType; productQuery: QueryType; orderDetails: boolean; }
 */
//# sourceMappingURL=types.js.map